import { defineMessages } from 'react-intl-next';

export default defineMessages({
	closePreviewLabel: {
		id: 'fabric.editor.ai.components.closePreviewIconButton.closePreviewLabel.non-final',
		defaultMessage: 'Close preview',
		description: 'Close preview button label and tooltip',
	},
});
